import React, { FC } from 'react';
import { IconProps } from './type';

export const IconInfoCircle: FC<React.PropsWithChildren<IconProps>> = ({ width = 20, height = 22, className = '' }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M10 3.5C5.86667 3.5 2.5 6.86667 2.5 11C2.5 15.1333 5.86667 18.5 10 18.5C14.1333 18.5 17.5 15.1333 17.5 11C17.5 6.86667 14.1333 3.5 10 3.5ZM10 16.8333C6.78333 16.8333 4.16667 14.2167 4.16667 11C4.16667 7.78333 6.78333 5.16667 10 5.16667C13.2167 5.16667 15.8333 7.78333 15.8333 11C15.8333 14.2167 13.2167 16.8333 10 16.8333ZM9.16667 9.75V15.1667H10.8333V9.75H9.16667ZM11.0417 7.875C11.0417 8.4503 10.5753 8.91667 10 8.91667C9.4247 8.91667 8.95833 8.4503 8.95833 7.875C8.95833 7.2997 9.4247 6.83333 10 6.83333C10.5753 6.83333 11.0417 7.2997 11.0417 7.875Z"
      fill="currentColor"
    />
  </svg>
);
